module.exports = __webpack_public_path__ + "img/logo_sg.e5c14d0e.png";